import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllAcademicYear = async () => {
  const response = await axios.get(apiPaths.baseUrl + `/api/year/all`, {
    headers: setHeaders(),
    withCredentials: setHeaders().withCredentials,
  });
  return response.data;
};

export const getAcademicYearById = async (idYear) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/year/${idYear}`, {
    headers: setHeaders(),
    withCredentials: setHeaders().withCredentials,
  });
  return response.data;
};

export const createAcademicYear = async (payload) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/year/create",
    payload,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};

export const updateAcademicYear = async (payload, id) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/year/${id}`,
    payload,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};

export const deleteAcademicYear = async (id) => {
  const response = await axios.delete(apiPaths.baseUrl + `/api/year/${id}`, {
    headers: setHeaders(),
    withCredentials: setHeaders().withCredentials,
  });
  return response.data;
};

export const createEvaluationPeriod = async (payload) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/evaluationPeriod/create",
    payload,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};

export const getAllEvaluationPeriod = async (idYear) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/evaluationPeriod/all/${idYear}`,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};

export const getEvaluationPeriodById = async (id) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/evaluationPeriod/${id}`,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};

export const getAllEvaluationPeriodByLevel = async (idLevel, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/evaluationPeriod/allByLevel/${idLevel}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateEvaluationPeriod = async (payload, id) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/evaluationPeriod/${id}`,
    payload,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};

export const deleteEvaluationPeriod = async (id) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/evaluationPeriod/${id}`,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};

export const getAllUE = async (idClass) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/ue/all/${idClass}`,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};

// -----------------Phase 3/4 (Param note)-------------------------------------------

// mettre à jour les paramètres des notes

export const updateNoteSettings = async (
  id_evaluationPeriod,
  payload,
  idYear,
) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/evaluationPeriod/paramNote/${id_evaluationPeriod}`,
    payload,
    { headers: setHeaders(), withCredentials: setHeaders().withCredentials },
  );
  return response.data;
};
